import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutocompleteComponent } from '../../../../common/autocomplete/autocomplete.component';
import { BaseComponent } from '../../../../common/base.component';
import { Rarity } from '../../../../models/enums';
import { FlaskFilter, GearHighlightConfig } from '../../../../models/filter-models';
import { BaseType } from '../../../../models/item-data-models';
import { FilterService } from '../../../../services/filter.service';
import { SelectRarityComponent } from '../../../../common/select/select-rarity/select-rarity.component';
import { ItemDataService } from '../../../../services/item-data.service';
import { SelectComponent } from '../../../../common/select/select.component';
import { SelectOptionComponent } from '../../../../common/select/select.component';
import { MyFlaskCharmHighlightsComponent } from './my-flask-charm-highlights/my-flask-charm-highlights.component';

@Component({
  selector: 'app-flask-filter',
  imports: [FormsModule, AutocompleteComponent, SelectRarityComponent, SelectComponent, SelectOptionComponent, MyFlaskCharmHighlightsComponent],
  templateUrl: './flask-filter.component.html',
  styleUrl: './flask-filter.component.scss'
})
export class FlaskFilterComponent extends BaseComponent implements OnInit {
  @Input({ required: true }) flask!: FlaskFilter;
  @Input({ required: true }) index!: number;
  @Output() remove = new EventEmitter<number>();

  hasHighlightConfig = 0;
  highlightConfigOpen = false;

  flaskClasses: BaseType[] = [];
  flaskBaseTypes: BaseType[] = [];

  classToNameMap: Record<string, string> = {
    'Life Flasks': 'Life',
    'Mana Flasks': 'Mana',
    'Hybrid Flasks': 'Hybrid',
    'Utility Flasks': 'Utility',
    'Tinctures': 'Tincture',
    'Charms': 'Charm',
  };

  constructor(private filterService: FilterService, private itemDataService: ItemDataService) {
    super();

    this.flaskClasses = [
      { name: 'Life Flasks', image: this.itemDataService.getItemData().find(i => i.itemClass === 'Life Flasks')!.baseTypes[8].image! },
      { name: 'Mana Flasks', image: this.itemDataService.getItemData().find(i => i.itemClass === 'Mana Flasks')!.baseTypes[8].image! },
    ];

    if (this.poe1) {
      this.flaskClasses.push(
        { name: 'Hybrid Flasks', image: this.itemDataService.getItemData().find(i => i.itemClass === 'Hybrid Flasks')!.baseTypes[0].image! },
        { name: 'Utility Flasks', image: this.itemDataService.getItemData().find(i => i.itemClass === 'Utility Flasks')!.baseTypes[0].image! },
        { name: 'Tinctures', image: this.itemDataService.getItemData().find(i => i.itemClass === 'Tinctures')!.baseTypes[0].image! },
      );
    } else {
      this.flaskClasses.push(
        { name: 'Charms', image: this.itemDataService.getItemData().find(i => i.itemClass === 'Charms')!.baseTypes[0].image! },
      );
    }
  }

  ngOnInit(): void {
    this.populateFlaskBaseTypes();

    this.hasHighlightConfig = this.getNumberOfHighlightConfig();
  }

  populateFlaskBaseTypes() {
    this.flaskBaseTypes = this.itemDataService.getItemData().find(i => i.itemClass === this.flask.flaskClass)!.baseTypes;
  }

  toggleHighlightConfigOpen() {
    this.highlightConfigOpen = !this.highlightConfigOpen;
  }

  getNumberOfHighlightConfig() {
    return GearHighlightConfig.hasChanges(this.flask.highlightConfig);
  }

  toggleShowFlask() {
    this.flask.show = !this.flask.show;
    if (!this.flask.show) {
      this.highlightConfigOpen = false;
    }
    this.updateFilter();
  }

  removeFlaskType() {
    this.remove.emit(this.index);
  }

  flaskClassChanged() {
    this.flask.flaskBaseTypes = ['All'];
    this.populateFlaskBaseTypes();
    this.updateFilter();
  }

  flaskBaseTypesChanged(flaskBaseTypes: string[]) {
    this.flask.flaskBaseTypes = flaskBaseTypes;
    this.updateFilter();
  }
  minRarityChanged(rarity: Rarity) {
    this.updateFilter();
  }

  qualityChanged() {
    this.updateFilter();
  }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
